import React, { useEffect, useState } from 'react';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';
import './NumberNew.css';
import axios from 'axios';

const NumberNew = () => {
  const { ref, inView } = useInView({ triggerOnce: false, threshold: 0.4 });
  const [statistics, setstatistics] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/list_statistics"
      );
      setstatistics(response.data.data);
    };
    fetchData();
  }, []);

  return (
    <section className="stats-section" ref={ref}>
      <div className="stats-grid">
        {statistics.map((stat, index) => (
          <div className="stat-box" key={index}>
            <h2 className="stat-value">
              {inView ? (
                <CountUp
                  end={parseInt((stat.value_number || "0").replace(/[^0-9]/g, ""), 10)}
                  duration={2}
                />
              ) : (
                '0'
              )}
              {stat.value_plus === "1" && "+"} {/* ✅ add plus if enabled */}
            </h2>
            <p className="stat-label">{stat.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default NumberNew;
